import { Component, OnInit } from '@angular/core';
import { getCurrentTab, TicketsChildTab, TicketsTabList } from './tickets.const';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'settings-tickets',
  templateUrl: './tickets.component.html',
  styleUrls: ['./tickets.component.css'],
})
export class TicketsComponent implements OnInit {
  public currentTab;
  public readonly ticketsTabList = TicketsTabList;

  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentTab = getCurrentTab(event.url);
      }
    });
  }

  ngOnInit() {
    this.currentTab = getCurrentTab(this.router.url);
  }

  onChangeTab(tabId: TicketsChildTab) {
    this.currentTab = tabId;
    this.router.navigate([tabId]);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/tickets/tickets.component.ts